/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./TopicMapperListEditor.vue?vue&type=template&id=be71b568&scoped=true"
import script from "./TopicMapperListEditor.vue?vue&type=script&lang=js"
export * from "./TopicMapperListEditor.vue?vue&type=script&lang=js"
import style0 from "./TopicMapperListEditor.vue?vue&type=style&index=0&id=be71b568&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "be71b568",
  null
  
)

export default component.exports